//import { Link, Route, Switch } from "react-router-dom";

import React, { Component } from "react";
import NavBar from "./NavBar";
import Footer from "../Helper/Footer";

class App extends Component {
  render() {
    return (
      <div className="App">
        <NavBar />
        <Footer />
      </div>
    );
  }
}

export default App;
